import React from 'react';
import Icon from '../../../components/AppIcon';

const SearchFilters = ({ searchQuery, onSearchChange, activeFilters, onFilterChange }) => {
  const hazardClasses = ['Flammable', 'Toxic', 'Corrosive', 'Carcinogen', 'Irritant', 'Reactive'];
  const physicalStates = ['Solid', 'Liquid', 'Gas'];
  const regulatoryStatuses = ['Regulated', 'Highly Regulated', 'Unregulated'];

  const handleFilterToggle = (category, value) => {
    const currentFilters = activeFilters?.[category] || [];
    const newFilters = currentFilters?.includes(value)
      ? currentFilters?.filter((f) => f !== value)
      : [...currentFilters, value];
    
    onFilterChange?.({
      ...activeFilters,
      [category]: newFilters
    });
  };

  const clearAllFilters = () => {
    onFilterChange?.({
      hazardClass: [],
      physicalState: [],
      regulatoryStatus: []
    });
    onSearchChange?.('');
  };

  const activeFilterCount =
    (activeFilters?.hazardClass?.length || 0) +
    (activeFilters?.physicalState?.length || 0) +
    (activeFilters?.regulatoryStatus?.length || 0);

  return (
    <div className="bg-card border border-border rounded-lg p-4 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-foreground">Search & Filters</h3>
        {activeFilterCount > 0 && (
          <button
            onClick={clearAllFilters}
            className="text-xs text-destructive hover:text-destructive/80 transition-colors"
          >
            Clear All ({activeFilterCount})
          </button>
        )}
      </div>
      {/* Search Input */}
      <div className="relative">
        <Icon
          name="Search"
          size={18}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
        />
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange?.(e?.target?.value)}
          placeholder="Search chemicals..."
          className="w-full pl-10 pr-4 py-2 bg-background border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
        />
      </div>
      {/* Hazard Class Filters */}
      <div>
        <h4 className="text-sm font-medium text-foreground mb-2">Hazard Classes</h4>
        <div className="space-y-2">
          {hazardClasses?.map((hazard) => (
            <label key={hazard} className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={activeFilters?.hazardClass?.includes(hazard) || false}
                onChange={() => handleFilterToggle('hazardClass', hazard)}
                className="rounded border-border text-primary focus:ring-primary"
              />
              <span className="text-sm text-foreground">{hazard}</span>
            </label>
          ))}
        </div>
      </div>
      {/* Physical State Filters */}
      <div>
        <h4 className="text-sm font-medium text-foreground mb-2">Physical State</h4>
        <div className="space-y-2">
          {physicalStates?.map((state) => (
            <label key={state} className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={activeFilters?.physicalState?.includes(state) || false}
                onChange={() => handleFilterToggle('physicalState', state)}
                className="rounded border-border text-primary focus:ring-primary"
              />
              <span className="text-sm text-foreground">{state}</span>
            </label>
          ))}
        </div>
      </div>
      {/* Regulatory Status Filters */}
      <div>
        <h4 className="text-sm font-medium text-foreground mb-2">Regulatory Status</h4>
        <div className="space-y-2">
          {regulatoryStatuses?.map((status) => (
            <label key={status} className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={activeFilters?.regulatoryStatus?.includes(status) || false}
                onChange={() => handleFilterToggle('regulatoryStatus', status)}
                className="rounded border-border text-primary focus:ring-primary"
              />
              <span className="text-sm text-foreground">{status}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchFilters;